import { Popover, Button, Icon } from 'components';
import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';

type AddUserPopoverProps = {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  setModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  setManualCoopModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
};

const AddUserPopover: React.FC<AddUserPopoverProps> = ({
  visible,
  setVisible,
  setModalVisible,
  setManualCoopModalVisible,
}) => (
    <ButtonContainer>
      <MainButton onClick={() => setModalVisible(true)}>Add User</MainButton>
      <Popover
        open={visible}
        onOpenChange={setVisible}
        trigger="click"
        placement="bottomRight"
        overlayStyle={{
          width: '200px',
        }}
        content={
          <div>
            <StyledButton
              type="text"
              block
              onClick={() => {
                setVisible(false);
                setModalVisible(true); // AddUserModal
              }}
            >
              Add User to Org
            </StyledButton>
            <StyledButton
              type="text"
              block
              onClick={() => {
                setVisible(false);
                setManualCoopModalVisible(true); // ManualCoopModal
              }}
            >
              Add Manual Co-op
            </StyledButton>
          </div>
        }
      >
        <MenuButton>
          <Icon type="antdEllipsisOutlined" />
        </MenuButton>
      </Popover>
    </ButtonContainer>
  );

export default AddUserPopover;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
`;

const MainButton = styled(Button)`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`;

const MenuButton = styled(Button)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding-left: 8px;
  padding-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledButton = styled(Button)`
  width: 40px;
  text-align: left;
`;
